import React from "react";
import {useOrganization} from "crqlar-react-common/dist/state/auth.reducer";
import type {SettingsNavigationId, SettingsSection} from "../settingsNavigation";
import {
    createSettingsEntityFindOptions,
    createSettingsEntitySearchProvider,
} from "./settingsSearchProviders";

type SettingsSearchConfigOptions = {
    sections: SettingsSection[]
    hasGuestAppModule: boolean
    canAccessSettingsItem: (settingsId: SettingsNavigationId) => boolean
}

export const useSettingsSearchConfig = ({
    sections,
    hasGuestAppModule,
    canAccessSettingsItem,
}: SettingsSearchConfigOptions) => {
    const organization = useOrganization()

    const items = React.useMemo(() => sections.flatMap(section => (
        section.items.map(item => ({...item, group: section.label}))
    )), [sections])

    const searchProvider = React.useMemo(() => createSettingsEntitySearchProvider({
        organizationId: organization?.id,
        includeContentCategories: hasGuestAppModule,
        canAccessSettingsItem,
    }), [canAccessSettingsItem, hasGuestAppModule, organization?.id])

    const findOptions = React.useMemo(() => createSettingsEntityFindOptions({
        organizationId: organization?.id,
        includeContentCategories: hasGuestAppModule,
        canAccessSettingsItem,
    }), [canAccessSettingsItem, hasGuestAppModule, organization?.id])

    return {items, searchProvider, findOptions}
}
